module.exports = __webpack_public_path__ + "img/monitor_cover_a.770d91b6.png";